import script from "./VerticalStepper.vue?vue&type=script&setup=true&lang=js"
export * from "./VerticalStepper.vue?vue&type=script&setup=true&lang=js"

import "./VerticalStepper.vue?vue&type=style&index=0&id=cb9594fa&lang=scss"

const __exports__ = script;

export default __exports__